/** A plain wallet outline for the bottom nav. Decorative; the nav label carries the name. */
export function BudgetIcon({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      aria-hidden="true"
      className={className}
    >
      <path d="M4 7h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z" strokeLinejoin="round" />
      <path d="M4 7l11-3v3" strokeLinejoin="round" />
      <path d="M16 13.5h2" strokeLinecap="round" />
    </svg>
  );
}
